import { makeStyles } from "$components/mui-styles";
import { Typography, type TypographyProps } from "@material-ui/core";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles((theme) => ({
  footerItem: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
}));

export type CardFooterItemProps = {
  /** Bold leading label, e.g. "Delivered:". The children are the value. */
  label?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
} & Omit<TypographyProps, "color">;

const CardFooterItem = ({
  label,
  children,
  className,
  ...props
}: CardFooterItemProps) => {
  const classes = useStyles();
  return (
    <Typography
      className={classNames(classes.footerItem, className)}
      {...props}
    >
      {label != null && (
        <>
          <strong>{label}</strong>{" "}
        </>
      )}
      {children}
    </Typography>
  );
};

export default CardFooterItem;
